<div class="modal-backdrop fixed inset-0 z-150 flex items-center justify-center p-4">
  <div class="modal-content w-full max-w-sm rounded-2xl overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-white/10">
      <h2 class="text-xl font-semibold text-text-primary">Mitarbeiternummer</h2>
      <button type="button" class="p-2 rounded-xl text-text-muted hover:text-text-primary hover:bg-white/10 transition-all" (click)="close()">
        <span class="material-icons text-xl">close</span>
      </button>
    </div>

    <!-- Enter submits the form, so the prefilled number can be confirmed without touching the mouse -->
    <form [formGroup]="form" (ngSubmit)="confirm()">
      <div class="p-6">
        <div class="form-group">
          <label for="employeeIdConfirm" class="form-label">Mitarbeiternummer</label>
          <input
            #employeeIdInput
            type="text"
            inputmode="numeric"
            autocomplete="off"
            id="employeeIdConfirm"
            formControlName="employeeId"
            class="form-input"
            [class.error]="isInvalid"
          />
          @if (errorText) {
            <span class="form-error">{{ errorText }}</span>
          }
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-white/10">
        <button type="button" class="btn-secondary px-5 py-2.5 text-sm" (click)="close()">Abbrechen</button>
        <button type="submit" class="btn-primary px-5 py-2.5 text-sm" [disabled]="isChecking()">Übernehmen</button>
      </div>
    </form>
  </div>
</div>
